import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VendorPartnership from "./pages/VendorPartnership";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VendorPartnership />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
